import { UserProfileMinimal } from './user.interface';
import { TopUpFrequency } from './employee.interface';

export interface SubscriptionCardRequest {
  name: string;
  holder: string;
  amount?: string;
  frequency?: TopUpFrequency;
  topup?: boolean;
}

export interface CardMinimal {
  type: CardType;
  name: string;
  masked_number: string;
  id: number;
  status?: CardStatus;
}

export interface CardMinimalHolder extends CardMinimal {
  holder: UserProfileMinimal;
}

export interface Card extends CardMinimalHolder {
  has_pin?: boolean;
  recurring_rule_id: number | null;
  created: string;
  exid: string;
  masked_number: string;
  expiry_date: string;
  monthly_limit: string;
  status: CardStatus;
  holder: UserProfileMinimal;
  balance?: string;
  block?: {
    employee: UserProfileMinimal;
    block_at: string;
    block_reason?: CardBlockReason;
    block_reason_other?: string;
  };
  remove?: {
    employee: UserProfileMinimal;
    created: string;
  };
}

export enum CardStatus {
  New = 0,
  Active = 1,
  Blocked = 10,
  Removed = 20,
}

export enum CardType {
  Personal = 1,
  Subscription = 2,
}

export enum CardStatusLabel {
  NEW = 'New',
  ACTIVE = 'Active',
  BLOCKED = 'Blocked',
  REMOVED = 'Removed',
}

export enum CardBlockReason {
  Fraud = 1,
  Other = 2,
  Lost = 3,
  Stolen = 4,
}

export interface CardBlockRequest {
  card: number;
  block_reason: number;
  block_reason_other: string;
}

export interface CardResponse {
  card: number;
}

export enum PeriodType {
  day,
  month,
  year,
}

export interface CardBalance {
  balance: string;
}

export interface CardLimits {
  balance: number;
  monthly: number;
  weekly: number;
  daily: number;
}

export enum CardFundType {
  Load = 1,
  Deduct = 2,
}

export interface CardFundsRequest {
  card: number;
  amount: string;
}

export interface CardFundsResponse extends CardFundsRequest {
  balance: string;
}

export interface CardFundsHistory {
  id: string;
  amount: string;
  created: string;
  creator: UserProfileMinimal;
  type: CardFundType;
  card: CardMinimalHolder;
}

export interface CardSdkConfig {
  card_id: string;
  key_id: string;
  key: string;
  otp: string;
  url: string;
}
